import { FC, HTMLAttributes, useMemo } from "react";
import { ITypographyProps } from "../Typography/Typography";
import { Image } from "@onmo/ui";
import GemIcon from "../../../assets/rankGem/webp/gem_1x.webp";
import GemIcon2x from "../../../assets/rankGem/webp/icon2x/gem_2x.webp";
import GemIcon3x from "../../../assets/rankGem/webp/icon3x/gem_3x.webp";
import VBIcon from "../../../assets/icon/vodabucks/vodabucks_1x.webp";
import VBIcon2x from "../../../assets/icon/vodabucks/vodabucks_2x.webp";
import VBIcon3x from "../../../assets/icon/vodabucks/vodabucks_3x.webp";
import GZCoinIcon from "../../../assets/icon/gamezone_coin/gamezone_coin_1x.webp";
import GZCoinIcon2x from "../../../assets/icon/gamezone_coin/gamezone_coin_2x.webp";
import GZCoinIcon3x from "../../../assets/icon/gamezone_coin/gamezone_coin_3x.webp";
import clsx from "classnames";
import { useStyles } from "./CoinNumber.style";

interface ICoinNumberProps extends ITypographyProps {
  amount: number;
  size?: number;
  type?: "vodabucks" | "gzcoins" | "gem" | "coin";
  reverse?: boolean;
  idCoin?: string;
}

export const CoinNumber: FC<
  ICoinNumberProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const {
    amount,
    size = 20,
    type = "gem",
    reverse,
    idCoin,
    ...otherProps
  } = props;
  const classes = useStyles();

  const coinIcon = useMemo(() => {
    switch (type) {
      case "vodabucks":
        return {
          icon: VBIcon,
          icon2x: VBIcon2x,
          icon3x: VBIcon3x,
        };
      case "gzcoins":
        return {
          icon: GZCoinIcon,
          icon2x: GZCoinIcon2x,
          icon3x: GZCoinIcon3x,
        };
      default:
        return {
          icon: GemIcon,
          icon2x: GemIcon2x,
          icon3x: GemIcon3x,
        };
    }
  }, [type]);

  return (
    <div
      className={clsx(classes.root, otherProps.className, { reverse })}
      {...otherProps}
    >
      <Image
        src={coinIcon.icon}
        src2x={coinIcon.icon2x}
        src3x={coinIcon.icon3x}
        width={size}
        height={size}
        id={idCoin}
      />
      <span id={`${idCoin}-nb`}>{amount}</span>
    </div>
  );
};
